// extracted by mini-css-extract-plugin
export default {"formField":"SupportRequestForm_formField__w-mDt","categoryField":"SupportRequestForm_categoryField__tu41v"};